import styled from 'styled-components';
import ObligationFormQuestionHelp from '../ObligationFormQuestionHelp';

export default function QuestionType5(props) {
  const { question } = props;

  return (
    <QuestionGroup>
      <Container color={question?.color}>{question.name}</Container>
      <ObligationFormQuestionHelp question={question} />
    </QuestionGroup>
  );
}

const Container = styled.div`
  font-size: 14pt;
  color: ${(props) => props.color ?? '#000000'};
`;
const QuestionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
`;